/* eslint-disable @typescript-eslint/no-non-null-assertion */
import {CollectionFactory, Reducer} from '@modifi/redux'
import {FileInfoView, getAuthenticatedThemisClient} from '@modifi/onboarding-api-clients'

const apiClient = getAuthenticatedThemisClient()

const {actions, selectors, reducer} = CollectionFactory<
  Record<string, any>,
  FileInfoView,
  {externalCompanyId: string},
  Record<string, never>
>({
  actionNamePrefix: `data/company-documents/collection`,
  rootSelector: state => state?.data?.companyDocuments?.collection,
  fetchRequest: () => apiClient.CompanyDocuments.fetch().then(res => res.data()?.files || []),
  entityPrimaryKeySelector: (entity: FileInfoView) => entity.fileId!,
})

export default reducer as Reducer

export const selectDocuments = (state: Record<string, any>): FileInfoView[] =>
  selectors.selectByKeyWindow(state, 'all')

export const selectDocumentsById = (state: Record<string, any>, id: string): FileInfoView =>
  selectors.selectById(state, id)

export const aFetchCompanyDocuments = (): any => actions?.fetch('all')

export const aAppendDocumentToCompanyInLocalStore = (document: FileInfoView): any =>
  actions!.appendEntity?.('all', {ident: document.fileId!, entity: document})

export const aRemoveDocumentFromCompanyInLocalStore = (fileId: string): any =>
  actions!.deleteEntity?.('all', fileId)
